<section
  class="tw-mx-4 tw-mb-4 tw-rounded-4 tw-border tw-border-solid tw-gradient-border-teal tw-shadow-z4 tw-flex tw-items-center tw-justify-between tw-pl-2 tw-pr-4 tw-py-2"
  (click)="handleClick()"
>
  <div class="tw-flex tw-gap-3 tw-items-center">
    <div class="tw-bg-gray-75 tw-overflow-hidden tw-rounded-lg tw-shrink-0 tw-w-14 tw-h-14">
      <img
        class="tw-w-full tw-h-full tw-object-cover"
        src="/assets/images/sand-watch-loader.gif"
        alt=""
      />
    </div>
    <span class="tw-font-body tw-font-bold tw-text-400 tw-text-gray-800" i18n="@@orderPrepration">We are preparing your treatment kit</span>
  </div>
  <cs-icon class="tw-h-4 tw-w-4 tw-shrink-0 tw-ml-2" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
</section>
